import { Icon } from '@chakra-ui/react';

export default function SFUnlockedIconOutlined(props) {
  return (
    <Icon
      width={14}
      height={14}
      viewBox='0 0 14 14'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M1.76562 13.5168C0.808594 13.5168 0.300781 12.9959 0.300781 11.9673V7.48161C0.300781 6.45947 0.808594 5.93864 1.76562 5.93864H7.09115V4.38916C7.09115 1.94124 8.6862 0.756348 10.3919 0.756348C12.0911 0.756348 13.6992 1.94124 13.6992 4.38916V5.69775C13.6992 6.1014 13.4648 6.27718 13.1849 6.27718C12.8919 6.27718 12.6641 6.08187 12.6641 5.69775V4.25244C12.6641 2.60531 11.6094 1.73942 10.3919 1.73942C9.17448 1.73942 8.11979 2.60531 8.11979 4.25244V5.97119C8.81641 6.1014 9.1875 6.60921 9.1875 7.48161V11.9673C9.1875 12.9959 8.67969 13.5168 7.72266 13.5168H1.76562ZM1.79818 12.5337H7.6901C7.97656 12.5337 8.13281 12.3579 8.13281 12.0389V7.40999C8.13281 7.09098 7.97656 6.92171 7.6901 6.92171H1.79818C1.51823 6.92171 1.35547 7.09098 1.35547 7.40999V12.0389C1.35547 12.3579 1.51823 12.5337 1.79818 12.5337Z' />
    </Icon>
  );
}
